// extracted by mini-css-extract-plugin
export var bottomMenu = "style-module--bottomMenu--66bb9";
export var categories = "style-module--categories--74633";
export var copyright = "style-module--copyright--575bd";
export var footer = "style-module--footer--937a4";
export var icon = "style-module--icon--d5d68";
export var icons = "style-module--icons--4e5c1";
export var item = "style-module--item--954fd";
export var label = "style-module--label--2f842";
export var list = "style-module--list--9049f";
export var logo = "style-module--logo--763e5";
export var othersMenu = "style-module--othersMenu--829e3";
export var sns = "style-module--sns--b5304";
export var special = "style-module--special--bff43";
export var top = "style-module--top--a634b";